import { ID, ISelectOption } from './utils';

export enum CourseStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
}

export interface ICourse {
  id: string;
  slug: string;
  name: string;
  description: string;
  clinicId: ID;
  status: CourseStatus;
  createdAt: string;
  updatedAt: string;
}

export type CourseView = Pick<ICourse, 'id' | 'name' | 'description' | 'clinicId' | 'status'>;

export type SelectOptionCourse = ISelectOption<CourseView>;
